import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {UploadableForm} from './uploadable-form.model';
import * as UploadableFormActions from './uploadable-form.actions';

export const uploadableFormsFeatureKey = 'uploadableForms';

export interface State extends EntityState<UploadableForm> {
  // additional entities state properties
}

export const adapter: EntityAdapter<UploadableForm> = createEntityAdapter<UploadableForm>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(UploadableFormActions.addUploadableForm,
    (state, action) => adapter.addOne(action.uploadableForm, state)
  ),
  on(UploadableFormActions.upsertUploadableForm,
    (state, action) => adapter.upsertOne(action.uploadableForm, state)
  ),
  on(UploadableFormActions.addUploadableForms,
    (state, action) => adapter.addMany(action.uploadableForms, state)
  ),
  on(UploadableFormActions.upsertUploadableForms,
    (state, action) => adapter.upsertMany(action.uploadableForms, state)
  ),
  on(UploadableFormActions.updateUploadableForm,
    (state, action) => adapter.updateOne(action.uploadableForm, state)
  ),
  on(UploadableFormActions.updateUploadableForms,
    (state, action) => adapter.updateMany(action.uploadableForms, state)
  ),
  on(UploadableFormActions.deleteUploadableForm,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(UploadableFormActions.deleteUploadableForms,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(UploadableFormActions.loadUploadableForms,
    (state, action) => adapter.setAll(action.uploadableForms, state)
  ),
  on(UploadableFormActions.clearUploadableForms,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
